import axios from 'axios';

const state = () => ({
    listings: [],
    filters: [],
    selectedFilters: [],
    loading: null,
})

const getters = {
    selectedFilters: state => {
        return state.filters
            .filter(filter => filter.selected !== null)
            .map(filter => {
                return filter.selected;
            });
    },

    filteredListings: (state, getters) => {
        if (getters.selectedFilters.length > 0) {
            return state.listings.filter(listing => {
                return getters.selectedFilters.every(filter => listing.filters.includes(filter));
            })
        } else {
            return state.listings;
        }
    }
}

const mutations = {
    updateListings(state, listings) {
        state.listings = listings;
    },

    updateFilters(state, filters) {
        state.filters = filters;
    },

    clearFilters(state) {
        state.filters = state.filters.map(filter => {
            filter.selected = null;
            return filter;
        })
    },

    setFilter(state, { key, value }) {
        const [filter] = state.filters.filter(filter => filter.key == key);
        filter.selected = value;
    },

    setLoading(state, loading) {
        state.loading = loading;
    }
}

const actions = {
    fetchListings({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('search').then(response => {
                const { data } = response;

                const filters = data.Filters.map(filter => ({
                    label: filter.Name || filter.Key,
                    selected: null,
                    key: filter.Key,
                    type: (filter.Options) ? 'select' : 'checkbox',
                    options: filter.Options.map(option => ({
                        value: option.Name,
                        text: option.Name,
                    }))
                }));

                let poolLabel = (data.Documents.length > 0) ? data.Documents[0].HasPoolLabel : 'Pool';

                filters.push({
                    label: poolLabel,
                    selected: null,
                    key: poolLabel,
                    type: 'checkbox',
                    value: 'HasPool'
                })


                const listings = data.Documents.map(listing => {

                    let filters = [
                        listing.RoomType,
                        listing.RoomSpace,
                        listing.RoomView,
                    ];

                    if (listing.Highlights !== '') {
                        filters.push(...listing.Highlights.split(','));
                    }

                    if (listing.RoomFeatures !== '') {
                        filters.push(...listing.RoomFeatures.split(','));
                    }

                    if (listing.HasPool) {
                        filters.push('HasPool');
                    }

                    return {
                        title: listing.TeaserTitle || listing.Title,
                        url: listing.Url,
                        image: listing.TeaserImage || '',
                        imageAlt: listing.TeaserImageAltText || '',
                        featured: false,

                        occupancyLabel: listing.OccupancyLabel,
                        hasPoolLabel: listing.HasPoolLabel,
                        dimensionsLabel: listing.DimensionsLabel,
                        highlight: listing.Highlights,
                        callToAction: listing.CallToActionText,

                        // filter data
                        hasPool: listing.HasPool,
                        roomType: listing.RoomType,
                        roomSpace: listing.RoomSpace,
                        roomView: listing.RoomView,
                        filters: filters.filter(filterValue => filterValue !== null && filterValue !== ''),
                    }

                });

                commit('updateFilters', filters);
                commit('updateListings', listings);

                resolve();
            }).catch(error => {
                reject(error);
            })
        });
    },

    setFilter({ commit }, [key, value]) {
        commit('setFilter', { key, value });
    },


}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}